(() => {
  const root = document.querySelector('#aq-respiro-product[data-pure-batch]');
  if (!root || root.dataset.modelBound) return;
  root.dataset.modelBound = 'true';
  const viewer = root.querySelector('model-viewer');
  const toggle = root.querySelector('.aq-model-toggle');
  if (!viewer || !toggle) return;
  const photo = root.querySelector('.aq-model-stage img');
  const status = root.querySelector('.aq-model-status');
  const colors = {steel:'#e8e8e8',gold:'#d4b163',lightgold:'#d7c7a4',copper:'#bf8969',gun:'#60646a',black:'#181a1b',white:'#ededeb'};
  let open = false, loaded = false;
  function finishModel() {
    const finish = root.querySelector('[data-finish][aria-pressed="true"]')?.dataset.finish || 'steel';
    const brushed = root.querySelector('[data-surface="brushed"]')?.getAttribute('aria-pressed') === 'true';
    const surface = ['black','white'].includes(finish) ? 'matte' : brushed ? 'brushed' : 'polished';
    const frames = JSON.parse(root.dataset.frames || '[]');
    root.style.setProperty('--aq-index', Math.max(0, frames.indexOf(finish+'-'+surface)));
    const painted = finish === 'black' || finish === 'white';
    for (const material of viewer.model?.materials || []) {
      if (material.name !== 'Acciaio lucido Super Mirror') continue;
      const pbr = material.pbrMetallicRoughness;
      const hex = (colors[finish] || colors.steel).slice(1);
      const rgba = [0, 2, 4].map(i => {
        const value = parseInt(hex.slice(i, i + 2), 16) / 255;
        return value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4;
      });
      pbr.setBaseColorFactor([...rgba, 1]);
      pbr.setMetallicFactor(painted ? 0 : 1);
      const satinRoughness = Number(root.querySelector('[data-satin-roughness]')?.dataset.satinRoughness || .24);
      pbr.setRoughnessFactor(painted ? .56 : brushed ? satinRoughness : .026);
    }
  }
  finishModel();
  viewer.addEventListener('load', () => {
    loaded = true;
    status.textContent = status.dataset.ready;
    finishModel();
  });
  viewer.addEventListener('error', () => {
    loaded = false;
    status.textContent = status.dataset.error;
  });
  root.addEventListener('click', event => {
    if (event.target.closest('[data-finish], [data-surface]')) finishModel();
  });
  toggle.addEventListener('click', () => {
    open = !open;
    if (open && !viewer.dataset.originalLoaded) {
      viewer.setAttribute('src', viewer.dataset.materialSrc);
      viewer.dataset.originalLoaded = 'true';
    }
    viewer.hidden = !open;
    photo.closest('.aq-atlas').hidden = open;
    status.hidden = !open;
    root.querySelector('[data-photo-caption]').hidden = open;
    root.querySelector('[data-model-caption]').hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen;
    if (!open) return;
    status.textContent = loaded ? status.dataset.ready : status.dataset.loading;
    if (!viewer.getAttribute('src')) {
      viewer.setAttribute('src', viewer.dataset.modelSrc);
      if (!customElements.get('model-viewer') && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error => {
          if (error) status.textContent = status.dataset.error;
        }}]);
      }
    }
    finishModel();
  });
})();

